// extracted by mini-css-extract-plugin
export default {"content":"input-checkbox-styles_component_content__Pat3e","unChecked":"input-checkbox-styles_component_unChecked__laxou","checked":"input-checkbox-styles_component_checked__V-7lc"};